<div class="col-lg-12">
    <br>
    <div>
        <h5>ADMINISTRACIÓN DE FONDO FIJO PARA SECCIONALES / DELEGACIONES</h5>
    </div>
    <br>
    <div class="form-group">
        <label for="inputbanco">Asignar dinero a Seccional/Deleg:</label>
        <select (click)="calcularSec(filtroSec)" [(ngModel)]="filtroSec" name="filtroSec" id="filtroSec" class="form-control">
            <option *ngFor="let sec of dataSourceSec" [ngValue]="sec.Codigo">Sec/Del: {{ sec.Descripcion }} - ({{ sec.Fondo_Fijo | currency:"$" }})</option>
        </select>

    </div>
    
    <div class="form-group">
        <label for="inputbanco">Importe:</label>
        <input type="number" [(ngModel)]="importe" name="importe" id="importe">
    </div>
    
    <button *ngIf="filtroSec && importe" type="button" class="btn btn-danger" (click)="updateFondoFijo()" > MODIFICAR ({{filtroSec}}) - ({{importe | currency:"$" }})</button>
    <hr>
    <app-loading class="m-5" *ngIf="loading"></app-loading>       
    <hr>  

    <div>
        <h5>Historico (ordenado por fecha)</h5>
    </div>
    
    <div id="DIVTABLA" *ngIf="contGrid > 0">
        <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
        </mat-form-field>
        <div class="example-container mat-elevation-z8">
            <table class="TABLITA" mat-table [dataSource]="dataSourceGrid" matSort>
                <!-- ID Column -->
                <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> id </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                </ng-container>
            
                <!-- Progress Column -->
                <ng-container matColumnDef="id_usuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> id_usuario </th>
                <td mat-cell *matCellDef="let row"> {{row.id_usuario}} </td>
                </ng-container>
            
                <!-- Name Column -->
                <ng-container matColumnDef="observacion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> observacion </th>
                <td mat-cell *matCellDef="let row"> {{row.observacion}} </td>
                </ng-container>
            
                <!-- Color Column -->
                <ng-container matColumnDef="fecha_movimiento">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> fecha_movimiento </th>
                <td mat-cell *matCellDef="let row"> {{row.fecha_movimiento | date:"dd/MM/yy"}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="categoria">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> categoria </th>
                        <td mat-cell *matCellDef="let row"> {{row.categoria}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>


</div>

